import { create } from 'zustand';

export type PageId =
  | 'hizmetler'
  | 'sektorel'
  | 'blog'
  | 'hakkimizda'
  | 'iletisim';

export type NavPhase = 'idle' | 'warping' | 'arrived' | 'returning';

interface NavigationState {
  page: PageId | null;
  phase: NavPhase;
  /** `performance.now()` at the moment the current transition started. */
  transitionStartedAt: number;

  navigateTo: (page: PageId) => void;
  returnHome: () => void;
  /** Internal — called by the camera animator when an animation completes. */
  setPhase: (phase: NavPhase) => void;
}

export const useNavigationStore = create<NavigationState>((set, get) => ({
  page: null,
  phase: 'idle',
  transitionStartedAt: 0,

  navigateTo(page) {
    if (get().phase !== 'idle') return;
    set({
      page,
      phase: 'warping',
      transitionStartedAt: performance.now(),
    });
  },

  returnHome() {
    const { phase } = get();
    if (phase === 'idle' || phase === 'returning') return;
    set({
      phase: 'returning',
      transitionStartedAt: performance.now(),
    });
  },

  setPhase(phase) {
    if (phase === 'idle') {
      set({ phase, page: null });
    } else {
      set({ phase });
    }
  },
}));
